import { authDelete } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { Integration } from "@pages/settings/types";

export const deleteIntegration = (
  deploymentId: string,
  integrationId: number
) => {
  return authDelete<Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integrationId}`
  );
};
